<template>

    <div class="outer-wrapper">

        <div class="title">

            <h1>Switch Roles</h1>
            <h2>current: {{ activeRole }}</h2>
        </div>
        <div class="role-list">

            <button v-for=" ( role, roleKey ) in userRoles " :key=" roleKey " @click=" switchRole( role )" class="button btn-green">{{ role }}</button>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'role-switch',
        methods: {

            ...mapActions({

                switchRole : 'auth/switchRole'
            })
        },
        computed: {

            ...mapGetters({

                modalContent : 'modal/modalContent',
                userRoles    : 'auth/allRoles',
                activeRole   : 'auth/activeRole'
            })
        }
    }

</script>

<style scoped>

    .outer-wrapper {

        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }
    p, h1, h2 {

        margin: 0;
    }
    .title {

        width: 100%;
        padding-bottom: 10px;
        box-shadow: 0px 3px 4px -3px #999;
        text-align: left;
        margin-bottom: 15px;
    }
    .title > h1 {

        color: #444;
    }
    .title > h2 {

        color: #999;
    }
    .role-list {

        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-top: 15px;
        width: 100%;
    }
    button {

        width: 155px;
        height: 60px;
        margin: 10px 0;
    }

</style>